<template>
  <div class="loading box_renew-loading">
    <div class="loading-wrap">
      <span class="box_loading-area">
        <img src="../images/loading.gif" alt="로딩중" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyLoading'
}
</script>

<style scoped>
.box_renew-loading .box_loading-area {
    display: flex;
    width: 80px;
    height: 80px;
    margin: auto;
    border-radius: 50%;
    background: #fff;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
}
.box_renew-loading .box_loading-area img {
  width: 60px;
}
</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyLoading.vue